import { useSyncExternalStore, useCallback } from 'react';
import type { Store } from '../../core/Store';
import type { PlayerState } from '../../core/types';

/**
 * React hook wrapping Store.subscribe via useSyncExternalStore.
 * Re-renders only when the selected value changes.
 */
export function useStore<T>(store: Store, selector: (state: PlayerState) => T): T {
  const subscribe = useCallback(
    (onStoreChange: () => void) => store.subscribe(selector, onStoreChange),
    [store, selector],
  );

  const getSnapshot = useCallback(
    () => selector(store.getState()),
    [store, selector],
  );

  return useSyncExternalStore(subscribe, getSnapshot);
}
